export default __webpack_public_path__ + "static/media/rank-6.f0d016df.webp";